export enum GovernanceActionType {
  InfoAction = 'InfoAction',
  TreasuryWithdrawal = 'TreasuryWithdrawals',
  HardFork = 'HardForkInitiation',
  UpdateToTheConstitution = 'NewConstitution',
  NoConfidence = 'NoConfidence',
  NewCommittee = 'NewCommittee',
  ProtocolParameterChange = 'ParameterChange',
}

export enum GovernanceActionFilterType {
  InfoAction = 'Info Action',
  TreasuryWithdrawals = 'Treasury Withdrawals',
  HardForkInitiation = 'HardFork Initiation',
  NewCommittee = 'Update Committee',
  NewConstitution = 'New Constitution',
  NoConfidence = 'Motion of no confidence',
  ParameterChange = 'Protocol Parameter Change',
}
